// 续填只保存完工页允许输入/选择的字段，详情归属、状态、客户及订单类型始终以服务端为准。
const EDITABLE_ORDER_FIELDS = [
  "detailAddress", "repairType", "deviceNum", "frontEndCable", "isSelfPickup",
  "powerSource", "cableBrandId", "cableBrandName", "lineLength", "addOutlay",
  "signExemption", "purchaseExtension", "isWiring", "houseType", "installTime",
  "oldDisposeType", "surveyImageUrl", "reserve1", "reserve3", "videoUrl",
];
const MATERIAL_FIELDS = ["typeId", "modelId", "meterialPrice", "num", "actualAmount"];
const COURIER_FIELDS = ["courierNum", "courierImageUrl", "courierImageUploader"];

function pick(source, fields) {
  const result = {};
  if (!source || typeof source !== "object") return result;
  fields.forEach(key => {
    if (Object.prototype.hasOwnProperty.call(source, key) && source[key] !== undefined) result[key] = source[key];
  });
  return result;
}

export function pickEditableOrderDetail(detail) {
  const result = pick(detail, EDITABLE_ORDER_FIELDS);
  if (detail && Array.isArray(detail.materialOrderList)) {
    // 物料选择和填写值可续填，旧物料记录ID、订单ID等后台字段不可恢复。
    result.materialOrderList = detail.materialOrderList.map(item => pick(item, MATERIAL_FIELDS));
  }
  return result;
}

export function mergeEditableOrderDetail(latest, cached, catalogs = {}) {
  const editable = pickEditableOrderDetail(cached);
  // 维修类型只有当前仍是维修单时可编辑，不能让旧草稿更改后台已调整的订单类型。
  if (latest.orderType !== 2) delete editable.repairType;
  if (editable.materialOrderList) {
    editable.materialOrderList = editable.materialOrderList.map(item => {
      const type = (catalogs.materials || []).find(option => String(option.value) === String(item.typeId));
      const model = type && (type.children || []).find(option => String(option.value) === String(item.modelId));
      const saved = (latest.materialOrderList || []).find(row => String(row.typeId) === String(item.typeId)
        && String(row.modelId) === String(item.modelId)) || {};
      return { ...item, typeName: type ? type.text : (saved.typeName || ""),
        modelName: model ? model.text : (saved.modelName || ""), allPrice: Number(item.meterialPrice || 0) * Number(item.num || 0) };
    });
  }
  // 普通电缆品牌名从最新字典取得；仅「其他」品牌名属于用户自由填写内容。
  const brandId = Object.prototype.hasOwnProperty.call(editable, "cableBrandId") ? editable.cableBrandId : latest.cableBrandId;
  if (String(brandId) !== "-1") {
    const brand = (catalogs.cableBrands || []).find(option => String(option.id) === String(brandId));
    editable.cableBrandName = brand ? brand.brandName : (brandId === latest.cableBrandId ? latest.cableBrandName : "");
  }
  return { ...latest, ...editable };
}

export function pickEditableCourier(courier) {
  return pick(courier, COURIER_FIELDS);
}

export function pickDraftTemplateImages(setting) {
  if (!setting || !Array.isArray(setting.templateDetailList)) return undefined;
  return {
    id: setting.id,
    templateDetailList: setting.templateDetailList.map(item => pick(item, ["id", "url", "miniUrl", "imageUploader"])),
  };
}
